// dashboardActions.js
import {
    FETCH_DASHBOARD,
    LOADING_DASHBOARD,
    SET_FILTRO_DASHBOARD,
    FETCH_TOTALIZADORES_TARJETA,
    FETCH_RESUMEN_ESTADOS,
    FETCH_TOP_PRODUCTOS,
    FETCH_TOP_CATEGORIAS,
    FETCH_TOP_TIPO_PUBLICACIONES
} from './types';

import {
    getTotalizadores,
    fetchDashboardTotalizadoresApi,
    getEstadoResumen,
    getTopProducto,
    getTopCategorias,
    getTopTipoPublicaciones
} from '../api/axios'; //  importar el que ya tenés



const emptyDashboardTotalizadores = {
    ventasDelMes: 0,
    comisionVentas: 0,
    ticketPromedio: 0,
    unidadesVendidas: 0,
    variacionMensualVentas: 0,
    variacionMensualUnidades: 0,
    variacionAnualVentas: 0,
    variacionAnualUnidades: 0,
    topProductos: []
};

const emptyResumenEstados = {
    total: 0,
    facturadas: 0,
    pendienteFacturar: 0,
    anuladas: 0
};

const normalizeTopProductosPayload = (resp) => {
    const root = resp?.data ?? resp ?? {};
    const topCandidate =
        root?.topProductos ??
        root?.TopProductos ??
        root?.topProductoDtoResponse ??
        root?.TopProductoDtoResponse ??
        root;

    const payload =
        topCandidate?.data?.topProductos ??
        topCandidate?.topProductos ??
        topCandidate?.TopProductos ??
        topCandidate?.topProductoDtoResponse ??
        topCandidate?.TopProductoDtoResponse ??
        topCandidate;

    return Array.isArray(payload) ? payload : [];
};

const normalizeTopCategoriasPayload = (resp) => {
    const root = resp?.data ?? resp ?? {};
    const payload =
        root?.data?.topCategorias ??
        root?.topCategorias ??
        root?.TopCategorias ??
        root;

    return Array.isArray(payload) ? payload : [];
};

const normalizeTopTipoPublicacionesPayload = (resp) => {
    const root = resp?.data ?? resp ?? {};
    const payload =
        root?.data?.topTipoPublicacion ??
        root?.topTipoPublicacion ??
        root?.TopTipoPublicacion ??
        root?.data?.topTipoPublicaciones ??
        root?.topTipoPublicaciones ??
        root?.TopTipoPublicaciones ??
        root;

    if (Array.isArray(payload)) {
        return payload;
    }

    if (Array.isArray(payload?.topTipoPublicacion)) {
        return payload.topTipoPublicacion;
    }

    if (Array.isArray(payload?.topTipoPublicaciones)) {
        return payload.topTipoPublicaciones;
    }

    return [];
};

export const setFiltroDashboard = (filtro) => dispatch => {
    dispatch({
        type: SET_FILTRO_DASHBOARD,
        payload: filtro
    });
};

//export const fetchDashboardCoreTotalizadores = (idSeller) => async (dispatch) => {
export const fetchDashboardCoreTotalizadores = (params) => async (dispatch) => {
    dispatch({
        type: LOADING_DASHBOARD,
        payload: true
    });

    try {
        // Normalizar params:
        // - si paso un id (number|string) -> { IdSeller: id }
        // - si paso null/undefined -> null (sin query)
        // - si ya es objeto -> lo uso tal cual
        const normalizedParams =
            params === null || params === undefined
                ? null
                : (typeof params === 'number' || typeof params === 'string')
                    ? { IdSeller: params }
                    : params;

        // Opcional: logging para depuración
        // console.debug('fetchDashboardCoreTotalizadores params:', normalizedParams);

        const resp = await getTotalizadores(normalizedParams);

        // Normalizo por si tu API viene envuelta o no y/o usa data de axios
        const root = resp?.data ?? resp;
        const tarjetas =
            root?.tarjetasDashboardDto ??
            root?.tarjetasDashboardDTO ??  // por si cambia el casing
            root?.tarjetaDashboardDtoHelperResponse ?? // fallback observado
            root;                          // si ya es el objeto

        dispatch({
            type: FETCH_TOTALIZADORES_TARJETA,
            payload: tarjetas, // <- esto queda guardado en el reducer
        });

        return tarjetas; // por si querés usar .then en el componente
    } catch (err) {
        console.error('fetchDashboardCoreTotalizadores error:', err);
        dispatch({
            type: FETCH_TOTALIZADORES_TARJETA,
            payload: emptyDashboardTotalizadores,
        });
        return emptyDashboardTotalizadores;
    } finally {
        dispatch({ type: LOADING_DASHBOARD, payload: false });
    }
};


export const fetchResumenEstadosDeOrdenes = (params) => async (dispatch) => {
    dispatch({
        type: LOADING_DASHBOARD,
        payload: true,
    });

    try {
        // Normalizar params
        const normalizedParams =
            params === null || params === undefined
                ? null
                : (typeof params === 'number' || typeof params === 'string')
                    ? { IdSeller: params }
                    : params;

        const resp = await getEstadoResumen(normalizedParams);
        const root = resp?.data ?? resp;

        // ⬇️ Normaliza: admite {resumenEstadosOrden:{...}} o el objeto plano {...}
        const resumen = root?.resumenEstadosOrden ?? root;

        dispatch({
            type: FETCH_RESUMEN_ESTADOS,
            payload: resumen,
        });

        return resumen;
    } catch (err) {
        console.error('fetchResumenEstadosDeOrdenes error:', err);
        dispatch({
            type: FETCH_RESUMEN_ESTADOS,
            payload: emptyResumenEstados,
        });
        return emptyResumenEstados;
    } finally {
        dispatch({
            type: LOADING_DASHBOARD,
            payload: false,
        });
    }
};


export const fetchTopProductosSeller = (params) => async (dispatch) => {

    // dispatch({ type: LOADING_DASHBOARD, payload: true });
    try {
        const normalizedParams =
            params === null || params === undefined
                ? null
                : (typeof params === 'number' || typeof params === 'string')
                    ? { IdSeller: params }
                    : params;

        const resp = await getTopProducto(normalizedParams);
        const payload = normalizeTopProductosPayload(resp);

        dispatch({
            type: FETCH_TOP_PRODUCTOS,
            payload: payload,
        });

        return payload;
    } catch (err) {
        console.error('fetchTopProductosSeller error:', err);
        dispatch({
            type: FETCH_TOP_PRODUCTOS,
            payload: [],
        });
        return [];
    } finally {
        // dispatch({ type: LOADING_DASHBOARD, payload: false });
    }
};


export const fetchTopCategorias = (params) => async (dispatch) => {
    try {
        const normalizedParams =
            params === null || params === undefined
                ? null
                : (typeof params === 'number' || typeof params === 'string')
                    ? { IdSeller: params }
                    : params;

        const resp = await getTopCategorias(normalizedParams);
        // Soporta camelCase y PascalCase sin cambiar tu lógica
        const top = normalizeTopCategoriasPayload(resp);
        dispatch({
            type: FETCH_TOP_CATEGORIAS,
            payload: top,
        });

        return top;
    } catch (err) {
        console.error('fetchTopCategorias error:', err);
        dispatch({
            type: FETCH_TOP_CATEGORIAS,
            payload: [],
        });
        return [];
    } finally {
        // dispatch({ type: LOADING_DASHBOARD, payload: false });
    }
};

export const fetchTopTipoPublicaciones = (params) => async (dispatch) => {
    try {
        const normalizedParams =
            params === null || params === undefined
                ? null
                : (typeof params === 'number' || typeof params === 'string')
                    ? { IdSeller: params }
                    : params;

        const resp = await getTopTipoPublicaciones(normalizedParams);
        const top = normalizeTopTipoPublicacionesPayload(resp);

        dispatch({
            type: FETCH_TOP_TIPO_PUBLICACIONES,
            payload: top,
        });

        return top;
    } catch (err) {
        console.error('fetchTopTipoPublicaciones error:', err);
        dispatch({
            type: FETCH_TOP_TIPO_PUBLICACIONES,
            payload: [],
        });
        return [];
    }
};
